import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView,
    meta: {
      keepAlive: true // 添加这个meta字段
    }
  },
  {
    path: '/aquarium',
    name: 'aquarium',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/Aquarium.vue')
  },
  {
    path:'/architecture',
    name:'architecture',
    component: () => import(/* webpackChunkName: "about" */ '../views/Architecture.vue')
  },
  {
    path:'/road-view',
    name:'road-view',
    component: () => import(/* webpackChunkName: "about" */ '../views/RoadView.vue')
  },
  {
    path:'/green-nature',
    name:'green-nature',
    component: () => import(/* webpackChunkName: "about" */ '../views/GreenNature.vue')
  },
  {
    path:'/night-scene',
    name:'night-scene',
    component: () => import(/* webpackChunkName: "about" */ '../views/NightScene.vue')
  },
  {
    path:'/about',
    name:'about',
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue'),
    meta: {
      skipLoading: true // 添加这个字段
    }
  },
  {
    path:'/contact',
    name:'contact',
    component: () => import(/* webpackChunkName: "about" */ '../views/Contact.vue')
  },
  {
    path:'/produce',
    name:'produce',
    component: () => import(/* webpackChunkName: "about" */ '../views/Produce.vue')
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
